const FileFolderUploader = {
  ADD_FILES_FOLDER_START: 'ADD_FILES_FOLDER_START',
  ADD_FILES_FOLDER_SUCCESS: 'ADD_FILES_FOLDER_SUCCESS',
  ADD_FILES_FOLDER_FAILURE: 'ADD_FILES_FOLDER_FAILURE',
  ADD_FILES_FOLDER_FINISHED: 'ADD_FILES_FOLDER_FINISHED'
};

export default FileFolderUploader;
